<template>
  <nav class="main-nav">
    <div class="nav-content" :class="{active: active, open: isOpen, animate: !dragging}">
      <div class="main-nav-header">
        <button class="nav-back" @click="close" aria-label="Close nav menu"></button>
        <button class="logo" @click="nav('/')" aria-label="Go to homepage">
          <span>Austin</span>
          <span>Studio</span>
          <span>Tour</span>
        </button>
      </div>

      <ul class="nav-list">
        <li class="nav-item" :class="{active: $route.name.includes('participant')}" @click="nav('/participants')">
          <button>Participants</button>
        </li>
        <li class="nav-item" :class="{active: $route.name === 'map'}" @click="nav('/map')">
          <button>Interactive Map</button>
        </li>
        <li class="nav-item" :class="{active: $route.name.includes('partner')}" @click="nav('/partners')">
          <button>Partners</button>
        </li>
        <li class="nav-item" :class="{active: $route.name === 'events'}" @click="nav('/events')">
          <button>Event Guide</button>
        </li>
        <!-- <li class="nav-item" :class="{active: $route.name === 'themedtours'}" @click="nav('/themedtours')">
          <button>Themed Tours</button>
        </li> -->
        <li class="nav-item" :class="{active: $route.name === 'about'}" @click="nav('/about')">
          <button>About</button>
        </li>
        <li class="nav-item" :class="{active: $route.name === 'thankyou'}" @click="nav('/thankyou')">
          <button>Thank You</button>
        </li>
        <li class="nav-item" :class="{active: $route.name === 'support'}" @click="nav('/support')">
          <button>Support</button>
        </li>
         <template v-if="$root.app">
          <li class="nav-item" :class="{active: $route.name === 'privacypolicy'}" @click="nav('/privacy-policy')">
            <button>Privacy Policy</button>
          </li>
         </template>
      </ul>

      <div class="nav-footer">
        <img src="../assets/img/bm.svg" width="201" height="62">
      </div>
    </div>

    <div class="page-overlay-backdrop" :class="{ open: isOpen, closing: isClosing }" @click="close"></div>
  </nav>
</template>

<script>
export default {
  data() {
    return {
      active: false,
      activeTimeout: null,
      isOpen: false,
      isClosing: false,
      pageContent: null,
      didDrag: false,
      dragging: false,
      dragStartPos: 0,
      dragDiff: 0,
      dragThreshold: -100,
    }
  },
  methods: {
    open() {
      clearTimeout(this.activeTimeout);
      this.active = true;
      this.pageContent.style = null;
      setTimeout(() => {
        this.isOpen = true;
      }, 50);
      document.body.classList.add('stop-scroll');
    },
    close() {
      this.isOpen = false;
      this.isClosing = true;
      this.activeTimeout = setTimeout(() => {
        this.isClosing = false;
        this.active = false;
      }, 500);
      document.body.classList.remove('stop-scroll');
    },
    nav(to) {
      if (!this.didDrag) {
        this.close();
        this.$router.push(to);
        this.$root.$children[0].transitionOverride = 'none';
      }
    },
    translateX(pos) {
      return "translate(" + pos + "px, 0)";
    },
  },
  mounted() {
    this.pageContent = this.$el.querySelector('.nav-content');

    let dragStart = e => {
      this.dragStartPos = e.touches[0].clientX;
    };
    let dragMove = e => {
      this.dragging = true;
      this.dragDiff = e.touches[0].clientX - this.dragStartPos;

      if (this.dragDiff < -10) {
        this.didDrag = true;
      }

      if (this.dragDiff < 0) {
        this.pageContent.style.transform = this.translateX(this.dragDiff);
      } else {
        this.pageContent.style.transform = this.translateX(0);
      }
    };
    let dragEnd = e => {
      this.dragging = false;
      this.pageContent.style.transform = null;

      if (this.dragDiff <= this.dragThreshold) {
        this.close();
      }

      this.dragDiff = 0;
      this.didDrag = false;
    };

    let xDown = null;
    let yDown = null;
    let draggedX = false;

    this.pageContent.addEventListener("touchstart", e => {
      xDown = e.touches[0].clientX;
      yDown = e.touches[0].clientY;
      dragStart(e);
    });
    this.pageContent.addEventListener("touchmove", e => {
      if (draggedX) dragMove(e);

      // Check if drag direction was along x
      // Prevents dragMove firing when scrolling page
      if (!xDown || !yDown) return;
      let xUp = e.touches[0].clientX;
      let yUp = e.touches[0].clientY;
      let xDiff = xDown - xUp;
      let yDiff = yDown - yUp;

      if (Math.abs(xDiff) > Math.abs(yDiff)) {
        draggedX = true;
      }

      xDown = null;
      yDown = null;
    });
    this.pageContent.addEventListener("touchend", e => {
      draggedX = false;
      dragEnd(e);
    });
  }
};
</script>

<style scoped lang="less">
@import '../css/variables';

.main-nav {
  .nav-content {
    display: none;
    justify-content: space-between;
    flex-direction: column;
    position: fixed;
    top: 0;
    left: 0;
    width: 80vw;
    max-width: 400px;
    height: 100dvh;
    transform: translateX(-100%);
    z-index: 9;
    background-color: @themeColor1;
    box-shadow: 0 3px 6px rgba(0, 0, 0, .30);
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    &.animate {
      transition: transform .5s;
    }
    &.active {
      display: flex;
    }
    &.open {
      transform: translateX(-1px);
      .logo {
        animation: fadeIn .5s both;
        animation-delay: 200ms;
      }
      .nav-item {
        button {
          animation: slideFromLeft 250ms both;
        }
      }
    }
    &.stop-scroll {
      .nav-item:active {
        opacity: 1;
      }
    }

    .main-nav-header {
      padding: 2vh 25px 4vh 25px;
      padding: calc(~"2vh + env(safe-area-inset-top)") 25px calc(~"4vh + env(safe-area-inset-bottom)") 25px;
      text-align: center;
      @media (max-width: @mobile) {
        padding: calc(~"2vh + env(safe-area-inset-top)") 25px 25px 25px;
      }
      .nav-back {
        display: block;
        width: 13px;
        height: 22px;
        margin-bottom: 2vh;
        background-size: 100%;
        background-position: center;
        background-image: url(../assets/img/nav-back.svg);
        z-index: 1;
        &:active {
          filter: brightness(.4);
        }
      }
      .logo {
        font-size: 56px;
        font-weight: 600;
        text-align: center;
        line-height: 56px;
        color: @themeColor2;
        @media (max-width: @mobile) {
          font-size: 51px;
          line-height: 51px;
        }
        span {
          display: block;
        }
      }
    }

    .nav-list {
      .nav-item {
        padding: 1.4vh 0;
        text-align: center;
        &.active {
          button {
            font-weight: bold;
          }
        }
        &:nth-child(1) {
          button {
            animation-delay: 250ms;
          }
        }
        &:nth-child(2) {
          button {
            animation-delay: 300ms;
          }
        }
        &:nth-child(3) {
          button {
            animation-delay: 350ms;
          }
        }
        &:nth-child(4) {
          button {
            animation-delay: 400ms;
          }
        }
        &:nth-child(5) {
          button {
            animation-delay: 450ms;
          }
        }
        &:nth-child(6) {
          button {
            animation-delay: 500ms;
          }
        }
        &:nth-child(7) {
          button {
            animation-delay: 550ms;
          }
        }
        &:nth-child(8) {
          button {
            animation-delay: 600ms;
          }
        }
        &:nth-child(9) {
          button {
            animation-delay: 650ms;
          }
        }
        &:nth-child(10) {
          button {
            animation-delay: 700ms;
          }
        }
      }
      button {
        font-size: 22px;
        color: @themeColor2;
        &:hover {
          color: @themeColor3;
        }
      }
    }

    .nav-footer {
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      align-items: center;
      padding-bottom: 20px;
      border: 0;
      &:active {
        filter: brightness(.4);
      }
    }
  }

  @media (max-width: @mobile) {
    .nav-content {
      .nav-list {
        .nav-item {
          padding: 1.2vh 0;
          button {
            font-size: 20px;
          }
        }
      }
    }
  }
}

@keyframes slideFromLeft {
  from {
    transform: translateX(-100vw);
  }
  50% {
    transform: translateX(15px);
  }
  to {
    transform: translateX(0);
  }
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MainNav.vue